import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { Typography } from '@material-ui/core';


import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const useStyles = makeStyles(theme => ({
  root: {
  },
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row_item: {
    display: 'flex',
  },
  itemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  itemInput: {
    width: '240px',
  },
  itemDateGap: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const SelectStartEndDate = props => {
  const { 
    className, 
    dateTitle,
    valueStartDate,
    onChangeStartDate, 
    valueEndDate,
    onChangeEndDate, 
    style, 
    ...rest } = props;

  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

      {/* <Typography
        className={classes.itemTitle}
        color="textSecondary"
        gutterBottom
      >
        {dateTitle}
      </Typography> */}

      <KeyboardDatePicker
        disableToolbar
        label='광고시작'
        required
        variant="inline"
        format="yyyy-MM-dd"
        margin="dense"
        id="startdate-picker-inline"
        value={valueStartDate}
        onChange={onChangeStartDate}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />

      <Typography
        className={classes.itemDateGap}
        color="textSecondary"
        gutterBottom
      >
        ~
      </Typography>

      <KeyboardDatePicker
        disableToolbar
        label='광고종료'
        required
        variant="inline"
        format="yyyy-MM-dd"
        margin="dense"
        id="enddate-picker-inline"
        value={valueEndDate}
        onChange={onChangeEndDate}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />

    </MuiPickersUtilsProvider>
  );
};

SelectStartEndDate.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

export default SelectStartEndDate;
